
export const regionMapping = {
  'gardameer': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'garda': {
    country: 'Italië', 
    region: 'Gardameer'
  },
  'lake garda': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'lago di garda': {
    country: 'Italië',
    region: 'Gardameer'
  },
  'costa brava': {
    country: 'Spanje',
    region: 'Costa Brava'
  },
  'costa del sol': {
    country: 'Spanje', 
    region: 'Costa del Sol'
  },
  'algarve': {
    country: 'Portugal',
    region: 'Algarve'
  },
  'toscane': {
    country: 'Italië',
    region: 'Toscane'
  },
  'tuscany': {
    country: 'Italië',
    region: 'Toscane'
  },
  'bretagne': {
    country: 'Frankrijk',
    region: 'Bretagne'
  },
  'brittany': {
    country: 'Frankrijk', 
    region: 'Bretagne'
  },
  'provence': {
    country: 'Frankrijk',
    region: 'Provence'
  },
  'côte d\'azur': {
    country: 'Frankrijk',
    region: 'Côte d\'Azur'
  },
  'cote d\'azur': {
    country: 'Frankrijk',
    region: 'Côte d\'Azur'
  },
  'french riviera': {
    country: 'Frankrijk',
    region: 'Côte d\'Azur'
  },
  'normandie': {
    country: 'Frankrijk',
    region: 'Normandië'
  },
  'normandië': {
    country: 'Frankrijk',
    region: 'Normandië'
  },
  'loire': {
    country: 'Frankrijk',
    region: 'Loire'
  },
  'loire vallei': {
    country: 'Frankrijk',
    region: 'Loire'
  },
  'dordogne': {
    country: 'Frankrijk',
    region: 'Dordogne'
  },
  'périgord': {
    country: 'Frankrijk',
    region: 'Dordogne'
  },
  'perigord': {
    country: 'Frankrijk',
    region: 'Dordogne'
  },
  'languedoc': {
    country: 'Frankrijk',
    region: 'Languedoc'
  },
  'roussillon': {
    country: 'Frankrijk',
    region: 'Languedoc-Roussillon'
  },
  'midi-pyrénées': {
    country: 'Frankrijk',
    region: 'Midi-Pyrénées'
  },
  'midi pyrenees': {
    country: 'Frankrijk',
    region: 'Midi-Pyrénées'
  },
  'aquitaine': {
    country: 'Frankrijk',
    region: 'Aquitaine'
  },
  'charente': {
    country: 'Frankrijk',
    region: 'Charente'
  },
  'vendée': {
    country: 'Frankrijk',
    region: 'Vendée'
  },
  'vendee': {
    country: 'Frankrijk',
    region: 'Vendée'
  },
  'ardèche': {
    country: 'Frankrijk',
    region: 'Ardèche'
  },
  'ardeche': {
    country: 'Frankrijk',
    region: 'Ardèche'
  },
  'lot': {
    country: 'Frankrijk',
    region: 'Lot'
  },
  'aveyron': {
    country: 'Frankrijk',
    region: 'Aveyron'
  },
  'gard': {
    country: 'Frankrijk',
    region: 'Gard'
  },
  'hérault': {
    country: 'Frankrijk',
    region: 'Hérault'
  },
  'herault': {
    country: 'Frankrijk',
    region: 'Hérault'
  },
  'var': {
    country: 'Frankrijk',
    region: 'Var'
  },
  'vaucluse': {
    country: 'Frankrijk',
    region: 'Vaucluse'
  },
  'luberon': {
    country: 'Frankrijk',
    region: 'Luberon'
  },
  'camargue': {
    country: 'Frankrijk',
    region: 'Camargue'
  },
  'cévennes': {
    country: 'Frankrijk',
    region: 'Cévennes'
  },
  'cevennes': {
    country: 'Frankrijk',
    region: 'Cévennes'
  },
  'auvergne': {
    country: 'Frankrijk',
    region: 'Auvergne'
  },
  'limousin': {
    country: 'Frankrijk',
    region: 'Limousin'
  },
  'bourgogne': {
    country: 'Frankrijk',
    region: 'Bourgogne'
  },
  'burgundy': {
    country: 'Frankrijk',
    region: 'Bourgogne'
  },
  'champagne': {
    country: 'Frankrijk',
    region: 'Champagne'
  },
  'alsace': {
    country: 'Frankrijk',
    region: 'Alsace'
  },
  'elzas': {
    country: 'Frankrijk',
    region: 'Alsace'
  },
  'franche-comté': {
    country: 'Frankrijk',
    region: 'Franche-Comté'
  },
  'jura': {
    country: 'Frankrijk',
    region: 'Jura'
  },
  'savoie': {
    country: 'Frankrijk',
    region: 'Savoie'
  },
  'haute-savoie': {
    country: 'Frankrijk',
    region: 'Haute-Savoie'
  },
  'alpen': {
    country: 'Frankrijk',
    region: 'Franse Alpen'
  },
  'franse alpen': {
    country: 'Frankrijk',
    region: 'Franse Alpen'
  },
  'pyreneeën': {
    country: 'Frankrijk',
    region: 'Franse Pyreneën'
  },
  'pyreneën': {
    country: 'Frankrijk',
    region: 'Franse Pyreneën'
  },
  'pyrenees': {
    country: 'Frankrijk',
    region: 'Franse Pyreneën'
  },
  'corsica': {
    country: 'Frankrijk',
    region: 'Corsica'
  },
  'korsika': {
    country: 'Frankrijk',
    region: 'Corsica'
  }
};
